var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRainbow(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 120,
    fill: "url(#paint0_linear_62_329)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 38H26C56.9279 38 82 63.0721 82 94V100H94C97.3137 100 100 97.3137 100 94C100 53.1309 66.8691 20 26 20C22.6863 20 20 22.6863 20 26V38Z",
    fill: "url(#paint1_radial_62_329)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M84 94H100C100 97.3137 97.3137 100 94 100H84V94Z",
    fill: "url(#paint2_linear_62_329)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26 20L26 36H20L20 26C20 22.6863 22.6863 20 26 20Z",
    fill: "url(#paint3_linear_62_329)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20 36H26C58.0325 36 84 61.9675 84 94V100H66V94C66 71.9086 48.0914 54 26 54H20V36Z",
    fill: "url(#paint4_radial_62_329)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M68 94H84V100H68V94Z",
    fill: "url(#paint5_linear_62_329)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20 52L20 36L26 36L26 52H20Z",
    fill: "url(#paint6_linear_62_329)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M20 62C20 65.3137 22.6863 68 26 68C40.3594 68 52 79.6406 52 94C52 97.3137 54.6863 100 58 100H68V94C68 70.804 49.196 52 26 52H20V62Z",
    fill: "url(#paint7_radial_62_329)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M52 94H68V100H58C54.6863 100 52 97.3137 52 94Z",
    fill: "url(#paint8_radial_62_329)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M26 68C22.6863 68 20 65.3137 20 62L20 52L26 52L26 68Z",
    fill: "url(#paint9_radial_62_329)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_62_329",
    x1: 60,
    y1: 0,
    x2: 60,
    y2: 120,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#174299"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#001E59"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_62_329",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(26 94) rotate(-90) scale(74)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.770277,
    stopColor: "#FF4000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8754C9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_62_329",
    x1: 83,
    y1: 97,
    x2: 100,
    y2: 97,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF4000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8754C9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_62_329",
    x1: 23,
    y1: 20,
    x2: 23,
    y2: 37,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8754C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF4000"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_62_329",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(26 94) rotate(-90) scale(58)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.723929,
    stopColor: "#FFF700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9901"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_62_329",
    x1: 68,
    y1: 97,
    x2: 84,
    y2: 97,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9901"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_62_329",
    x1: 23,
    y1: 52,
    x2: 23,
    y2: 36,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9901"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_62_329",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(26 94) rotate(-90) scale(42)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.59513,
    stopColor: "#00AAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01DA40"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_62_329",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(51 97) scale(17 45.3333)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00AAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01DA40"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_62_329",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23 69) rotate(-90) scale(17 322.37)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00AAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01DA40"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRainbow);
export default __webpack_public_path__ + "static/media/rainbow.ad2b3191d3a6cac0a4540947b8906fc2.svg";
export { ForwardRef as ReactComponent };